import { AdminLayout } from '@/components/admin/AdminLayout';
import { Crown, User } from 'lucide-react';

export const AdminPlans = () => {
  const plans = [
    {
      id: 'free',
      name: '無料プラン',
      price: 0,
      icon: User,
      color: 'gray',
      features: [
        'プロジェクト管理',
        'タイムトラッキング',
        'クライアント管理',
        'カレンダー機能',
        '基本レポート',
      ],
    },
    {
      id: 'pro',
      name: 'Proプラン',
      price: 980,
      icon: Crown,
      color: 'purple',
      features: [
        '無料プランの全機能',
        'Googleカレンダー連携',
        '高度なレポート',
        'PDFエクスポート',
        'プライオリティサポート',
      ],
    },
  ];

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* ページヘッダー */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">プラン管理</h1>
          <p className="text-gray-600 mt-1">料金プランの設定と管理</p>
        </div>

        {/* プランカードグリッド */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {plans.map((plan) => {
            const Icon = plan.icon;
            const isGray = plan.color === 'gray';
            
            return (
              <div
                key={plan.id}
                className={`card ${
                  isGray
                    ? 'border-2 border-gray-200'
                    : 'border-2 border-purple-200 bg-gradient-to-br from-purple-50 to-white'
                }`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <Icon
                        className={`w-6 h-6 ${
                          isGray ? 'text-gray-600' : 'text-purple-600'
                        }`}
                      />
                      <h3 className="text-xl font-bold text-gray-900">
                        {plan.name}
                      </h3>
                    </div>
                    <div className="flex items-baseline gap-1">
                      <span className="text-3xl font-bold text-gray-900">
                        ¥{plan.price.toLocaleString()}
                      </span>
                      <span className="text-sm text-gray-500">/月</span>
                    </div>
                  </div>
                  
                  {/* 編集ボタン（将来的な拡張用） */}
                  {/* 
                    現在、プラン情報はコード内で管理されています。
                    動的に編集可能にする場合は、Firestoreに保存する必要があります。
                  */}
                  <button
                    className={`px-4 py-2 rounded-lg font-medium transition ${
                      isGray
                        ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        : 'bg-purple-600 text-white hover:bg-purple-700'
                    }`}
                    onClick={() => alert('プラン編集機能は開発中です。\n現在、プラン情報はコードで管理されています。')}
                  >
                    編集
                  </button>
                </div>

                <div className="space-y-3">
                  <h4 className="text-sm font-semibold text-gray-700">機能一覧</h4>
                  <ul className="space-y-2">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2 text-sm text-gray-600">
                        <svg
                          className={`w-5 h-5 flex-shrink-0 ${
                            isGray ? 'text-gray-400' : 'text-purple-500'
                          }`}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {/* プラン統計 */}
        <div className="card">
          <h2 className="text-lg font-bold text-gray-900 mb-4">プラン別統計</h2>
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded-lg">
            <p className="text-gray-500">統計グラフは実装予定...</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};
